/**
 * Stock is adjusted in whole units. The API refuses a fraction (SCRUM-1985: it
 * used to truncate 2.5 to 2 and answer 200), so both adjust forms check first
 * and say the same thing the server would.
 */
export const WHOLE_UNITS_MESSAGE = 'Enter a whole number — stock can’t be adjusted by part of a unit.';

export type StockQuantityCheck =
  | { ok: true; quantity: number }
  | { ok: false; reason: 'missing' | 'not-positive' | 'fraction' };

/** Parse a typed adjustment quantity: a whole number above zero. */
export function checkStockQuantity(input: string): StockQuantityCheck {
  const trimmed = input.trim();
  if (trimmed === '') return { ok: false, reason: 'missing' };

  const value = Number(trimmed);
  if (!Number.isFinite(value) || value <= 0) return { ok: false, reason: 'not-positive' };
  if (!Number.isInteger(value)) return { ok: false, reason: 'fraction' };

  return { ok: true, quantity: value };
}
